<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-half">
        <form ref="form">
          <b-field label="Email">
            <b-input v-model="mail" type="email" value="example@" maxlength="256" required>
            </b-input>
          </b-field>
          <b-field label="Password">
            <b-input
              v-model="password"
              type="password"
              value="iwantmytreasure"
              password-reveal
              required
            >
            </b-input>
          </b-field>
          <b-button size="is-large" :disabled="isDisabled" @click="login">ログイン</b-button>
        </form>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
      style="background-color: rgba(0, 0, 0, 0.8)"
    ></b-loading>
  </div>
</template>

<script>
import AuthService from '../services/AuthService';

export default {
  name: 'AdminLogin',
  data() {
    return {
      mail: '',
      password: '',
      isLoading: false,
      isDisabled: true,
    };
  },
  watch: {
    mail: function () {
      const valid = this.$refs.form.checkValidity();
      this.isDisabled = !valid;
    },
    password: function () {
      const valid = this.$refs.form.checkValidity();
      this.isDisabled = !valid;
    },
  },
  methods: {
    login: function () {
      const authService = new AuthService();
      this.isLoading = true;
      authService.login(this.mail, this.password, (isLoggedIn) => {
        this.isLoading = false;
        if (isLoggedIn) {
          this.$buefy.toast.open('ログインしました。');
          setTimeout(() => {
            this.$router.push('/');
          }, 1000);
        } else {
          this.$buefy.dialog.alert('ログインに失敗しました');
        }
      });
    },
  },
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/AdminLogin.vue